module.exports = __webpack_public_path__ + "img/album23_10.e746046c.jpg";